(function () {
  function handleSwiperStateChange(swiper) {
    if (swiper.slides[swiper.activeIndex].classList.contains('bi-slide--dark')) {
      swiper.pagination.el.classList.add('white-skin');
    } else {
      swiper.pagination.el.classList.remove('white-skin');
    }
  }

  let swiper;

  function init() {
    swiper = new Swiper('.bi-slideshow.swiper', {
      speed: 1000,
      slidesPerView: 1,
      autoplay: {
        delay: 2200,
      },
      on: {
        afterInit: (swiper) => handleSwiperStateChange(swiper),
        slideChange: (swiper) => handleSwiperStateChange(swiper),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => {
    if (!e.target.classList.contains('bi-slide')) return;

    const slides = document.querySelectorAll('.bi-slideshow .bi-slide');

    slides?.forEach((currentSlide, currentIndex) => {
      if (e.target === currentSlide) {
        swiper.slideTo(currentIndex);
      }
    });

    swiper.autoplay.stop();
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    if (!e.target.classList.contains('bi-slide')) return;

    swiper.autoplay.start();
  });
})();
